import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { caseService } from '../services/api';
import { formatCaseStatus } from '../utils/caseStatus';
import '../styles/CasesList.css';

export default function CasesList() {
  const { user } = useContext(AuthContext);
  const [cases, setCases] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const loadCases = async () => {
      if (!user?.officeId) {
        setError('User session information is missing. Please log in again.');
        setLoading(false);
        return;
      }

      setLoading(true);
      setError('');

      try {
        const response = await caseService.getCasesByOffice(user.officeId);
        setCases(Array.isArray(response.data) ? response.data : []);
      } catch (err) {
        const responseMessage = typeof err.response?.data === 'string'
          ? err.response.data
          : err.response?.data?.message;
        setError(responseMessage || 'Failed to load cases');
      } finally {
        setLoading(false);
      }
    };

    loadCases();
  }, [user?.officeId]);

  if (loading) {
    return <div className="cases-page"><p className="cases-state">Loading cases...</p></div>;
  }

  return (
    <div className="cases-page">
      <div className="cases-header">
        <div>
          <h2>My Cases</h2>
          <p>{cases.length} case{cases.length === 1 ? '' : 's'} in this office</p>
        </div>
        <Link to="/create-case" className="new-case-link">Create Case</Link>
      </div>

      {error && <p className="error">{error}</p>}

      {!error && cases.length === 0 ? (
        <div className="cases-empty">
          <h3>No cases yet</h3>
          <p>Create a case to see it listed here.</p>
        </div>
      ) : (
        <div className="cases-table-wrap">
          <table className="cases-table">
            <thead>
              <tr>
                <th>Case Number</th>
                <th>Title</th>
                <th>Client</th>
                <th>Type</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {cases.map((caseItem) => (
                <tr key={caseItem.id}>
                  <td>{caseItem.caseNumber}</td>
                  <td>{caseItem.title}</td>
                  <td>{caseItem.clientName || '-'}</td>
                  <td>{caseItem.caseType || '-'}</td>
                  <td>
                    <span className={`case-status ${String(caseItem.status || '').toLowerCase()}`}>
                      {formatCaseStatus(caseItem.status)}
                    </span>
                  </td>
                  <td>
                    <Link to={`/case/${caseItem.id}`} className="view-case-link">
                      View
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
